import React from 'react';
import { Link } from 'react-router-dom';
export function FitnessRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-1455">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1456">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-1457">
          Explore More Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-1458">
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1459">
            Adult Classes
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1460">
            Family Classes
          </Link>
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1461">
            Kids Classes
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1462">
            Programs Overview
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1463">
            Start Trial
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1464">
            Contact
          </Link>
        </div>
      </div>
    </section>;
}